// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Combobox } from '@node-space/ui-components'
import useFilterMerchant from 'components/FilterBar/hooks/useFilterMerchant'
import { useMerchantsQuery } from 'hooks/queries/useMerchantsQuery'
import { PaymentMerchantDefault } from 'types/payments'
import { titleCase } from 'utils/utils'

interface FilterMerchantProps {
  onMerchantSelected: (value: string) => void
}

const FilterMerchant = ({ onMerchantSelected }: FilterMerchantProps) => {
  const { t } = useTranslation()

  const { data: { merchantListOptions: options = [] } = {} } = useMerchantsQuery()

  const { merchant } = useFilterMerchant()

  const merchantListOptions = () => {
    return [
      { value: PaymentMerchantDefault.ALL, leftText: titleCase(PaymentMerchantDefault.ALL) },
      ...options,
    ]
  }

  const onMerchantChange = merchant => {
    onMerchantSelected(merchant)
  }

  return (
    <Combobox
      label={t('merchantId')}
      id="merchant"
      data-testid="filter-merchant-field"
      defaultValue={merchant}
      onChange={onMerchantChange}
      items={merchantListOptions()}
      modal
    />
  )
}

export default FilterMerchant
